"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
var _classnames = _interopRequireDefault(require("classnames"));
var _Terms = _interopRequireDefault(require("./Terms"));
var _utils = require("@site/utils");
// eslint-disable-next-line complexity
const StandardTermsPricing = ({
  aftermarketPremiumPricingDisplay,
  annualPricingDisplay,
  celebrateIsOn = false,
  displayMonthlyPricing,
  hideListPrice,
  isHighlightSavings = false,
  isMobile,
  isPremiumPrice,
  isPriceConsistent,
  isPromoPayVariant = false,
  isTwoCardLayout = false,
  monthlyPricingDisplay,
  privateLabelId,
  samePriceEachYear,
  showFreeIndicator,
  showMonthlyPriceDisclaimer,
  styleOverrides,
  termLength,
  hasMultiYearTerm
}) => {
  const monthlyNonPremiumPrice = /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: "dppSolutionsPricePerMonth",
    values: {
      price: monthlyPricingDisplay.currentPriceDisplay
    }
  });
  const annualNonPremiumPrice = samePriceEachYear ? /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: "dppSolutionsPricePerYear",
    values: {
      price: annualPricingDisplay.currentPriceDisplay
    }
  }) : annualPricingDisplay.currentPriceDisplay;
  const nonPremiumPrice = displayMonthlyPricing ? monthlyNonPremiumPrice : annualNonPremiumPrice;
  const nonPremiumPricingDisplay = showFreeIndicator ? /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: "pricing.display.free-label"
  }) : nonPremiumPrice;
  const strikePriceClassname = (0, _classnames.default)('d-inline-block mr-2', {
    'text-muted': !styleOverrides?.strikethroughPriceStyle?.color && !isPromoPayVariant && (0, _utils.isReseller)(privateLabelId)
  });
  const mainPriceClassname = (0, _classnames.default)('d-inline-block mr-2', {
    ms3: !styleOverrides?.mainPriceStyle?.fontSize && isTwoCardLayout
  }, {
    'font-weight-bold ': isPromoPayVariant
  });
  const disclaimerClassname = (0, _classnames.default)('d-inline-block align-items-md-start', {
    'text-muted': !styleOverrides?.disclaimerStyle?.color && !isPromoPayVariant && (0, _utils.isReseller)(privateLabelId)
  }, {
    'ms-3': isMobile && (isPromoPayVariant || isHighlightSavings)
  });
  const shouldNotCenter = (isHighlightSavings || isPromoPayVariant) && !celebrateIsOn;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "terms-pricing",
    className: (0, _classnames.default)({
      'text-center': isMobile && hasMultiYearTerm && !shouldNotCenter
    })
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('d-flex align-items-baseline flex-wrap', {
      'justify-content-center': isMobile
    })
  }, /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": "terms-pricing-price-line",
    className: (0, _classnames.default)('d-flex flex-row-reverse align-items-baseline', {
      'justify-content-end': !isMobile,
      'justify-content-center': isMobile
    })
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: mainPriceClassname,
    style: styleOverrides?.mainPriceStyle,
    "data-testid": "terms-pricing-main-price"
  }, isPremiumPrice ? aftermarketPremiumPricingDisplay : nonPremiumPricingDisplay), !hideListPrice && !isPremiumPrice && !isPriceConsistent && /*#__PURE__*/_react.default.createElement("del", {
    className: strikePriceClassname,
    style: styleOverrides?.strikethroughPriceStyle,
    "data-testid": "terms-pricing-list-price"
  }, displayMonthlyPricing ? monthlyPricingDisplay.listPriceDisplay : annualPricingDisplay.listPriceDisplay)), !isPremiumPrice && !samePriceEachYear && /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": "terms",
    className: disclaimerClassname,
    style: styleOverrides?.disclaimerStyle
  }, /*#__PURE__*/_react.default.createElement(_Terms.default, {
    isPromoPayVariant: isPromoPayVariant,
    isHighlightSavings: isHighlightSavings,
    hasMultiYearTerm: hasMultiYearTerm,
    minimumYears: termLength,
    showMonthlyPriceDisclaimer: showMonthlyPriceDisclaimer,
    showExactMonthlyPrice: displayMonthlyPricing
  }))));
};
StandardTermsPricing.propTypes = {
  aftermarketPremiumPricingDisplay: _propTypes.default.string,
  annualPricingDisplay: _propTypes.default.object,
  celebrateIsOn: _propTypes.default.bool,
  displayMonthlyPricing: _propTypes.default.bool,
  hasMultiYearTerm: _propTypes.default.bool,
  hideListPrice: _propTypes.default.bool,
  isHighlightSavings: _propTypes.default.bool,
  isMobile: _propTypes.default.bool,
  isPremiumPrice: _propTypes.default.bool.isRequired,
  isPriceConsistent: _propTypes.default.bool,
  isPromoPayVariant: _propTypes.default.bool,
  isTwoCardLayout: _propTypes.default.bool,
  monthlyPricingDisplay: _propTypes.default.object,
  samePriceEachYear: _propTypes.default.bool,
  showFreeIndicator: _propTypes.default.bool,
  showMonthlyPriceDisclaimer: _propTypes.default.bool,
  styleOverrides: _propTypes.default.shape({
    mainPriceStyle: _propTypes.default.object,
    strikethroughPriceStyle: _propTypes.default.object,
    disclaimerStyle: _propTypes.default.object
  }),
  termLength: _propTypes.default.number
};
var _default = exports.default = StandardTermsPricing;